import { DateTime } from "luxon";

// The date to record when a vehicle is marked collected: the booked date, so a collection logged
// after the fact lands on the right day, but never a booking still to come. A car collected early
// (booked for next week, picked up today) used to take its future booking with it, and DVLA refuses
// a COD dated in the future. The API clamps the same way (CollectionDateRules).
export function resolveCollectedDate(
  scheduledCollectionOn: string | null | undefined,
  now: DateTime = DateTime.now()
): DateTime {
  if (!scheduledCollectionOn) return now;

  const scheduled = DateTime.fromISO(scheduledCollectionOn);

  return scheduled.isValid && scheduled.startOf("day") <= now.startOf("day") ? scheduled : now;
}
